"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Button = require("../Button");

var _Button2 = _interopRequireDefault(_Button);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledWrapper = _styledComponents2.default.div.withConfig({
  displayName: "TopHeaderProfile__StyledWrapper",
  componentId: "sc-1qf5e4z-0"
})(["display:flex;justify-content:center;align-items:center;width:36px;"]);

const AvatarWrapper = _styledComponents2.default.div.withConfig({
  displayName: "TopHeaderProfile__AvatarWrapper",
  componentId: "sc-1qf5e4z-1"
})(["align-items:center;display:flex;height:36px;justify-content:center;width:36px;position:relative;"]);

const StyledButton = _styledComponents2.default.button.withConfig({
  displayName: "TopHeaderProfile__StyledButton",
  componentId: "sc-1qf5e4z-2"
})(["background:none;border:0;cursor:pointer;height:100%;outline:none;padding:0;width:100%;border:", ";border-radius:100%;&:hover{border:1px solid ", ";}& img{height:100%;width:100%;border-radius:100%;}"], props => props.showMenu ? `1px solid ${_styles.colors.white}` : `1px solid ${_styles.colors.lightestWhite}`, _styles.colors.lightWhite);

const StyledMenu = _styledComponents2.default.div.withConfig({
  displayName: "TopHeaderProfile__StyledMenu",
  componentId: "sc-1qf5e4z-3"
})(["display:", ";background-color:", ";border:1px solid ", ";box-shadow:0 4px 12px 0 rgba(21,25,30,0.05000000074505806);border-radius:6px;top:52px;right:-3px;margin:0px;padding:", "px ", "px;position:absolute;white-space:nowrap;z-index:3;a{font-family:", ";font-size:14px;text-decoration:none;color:", ";display:block;:not(:first-child){margin-top:10px;}}::before{position:absolute;display:block;content:\"\";right:10px;top:-10px;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid ", ";}::after{position:absolute;display:inline-block;content:\"\";right:11px;top:-9px;border-left:9px solid transparent;border-right:9px solid transparent;border-bottom:9px solid ", ";}"], props => props.showMenu ? "flex" : "none", _styles.colors.white, _styles.colors.border, (0, _styles.calcPadding)(5) - 1, (0, _styles.calcPadding)(6) - 1, _styles.fontFamily1, _styles.colors.black, _styles.colors.topHeaderProfileBorder, _styles.colors.white);

const UserInfo = _styledComponents2.default.div.withConfig({
  displayName: "TopHeaderProfile__UserInfo",
  componentId: "sc-1qf5e4z-4"
})(["display:inline-block;vertical-align:middle;position:relative;"]);

const UserText = _styledComponents2.default.div.withConfig({
  displayName: "TopHeaderProfile__UserText",
  componentId: "sc-1qf5e4z-5"
})(["", " display:flex;flex-direction:column;margin-right:32px;color:", ";margin-top:4px;margin-bottom:4px;line-height:14px;"], _styles.defaultBody, _styles.colors.black);

const LoggedInAs = _styledComponents2.default.span.withConfig({
  displayName: "TopHeaderProfile__LoggedInAs",
  componentId: "sc-1qf5e4z-6"
})(["font-size:12px;opacity:0.7;margin-bottom:4px;"]);

class TopHeaderProfile extends _react.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      showMenu: false
    }, this.onProfileClick = () => {
      const { showMenu } = this.state;
      this.setState({ showMenu: !showMenu });
    }, _temp;
  }

  componentWillUpdate(nextProps, nextState) {
    // Set up event listeners to determine to hide profile menu when user clicks outside the component
    if (nextState.showMenu) {
      document.addEventListener("click", this.onProfileClick);
    } else {
      document.removeEventListener("click", this.onProfileClick);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onProfileClick);
  }

  render() {
    const _props = this.props,
          { onClick, user } = _props,
          props = _objectWithoutProperties(_props, ["onClick", "user"]);
    const { showMenu } = this.state;

    return _react2.default.createElement(
      StyledWrapper,
      props,
      _react2.default.createElement(
        AvatarWrapper,
        null,
        _react2.default.createElement(
          StyledButton,
          {
            "data-id": "avatar",
            onClick: () => this.onProfileClick(),
            showMenu: showMenu
          },
          _react2.default.createElement("img", { src: user.avatar, alt: "avatar" })
        ),
        _react2.default.createElement(
          StyledMenu,
          { showMenu: showMenu },
          _react2.default.createElement(
            UserInfo,
            null,
            _react2.default.createElement(
              UserText,
              null,
              _react2.default.createElement(
                LoggedInAs,
                null,
                "Currently logged in as"
              ),
              _react2.default.createElement(
                "strong",
                null,
                user.email
              )
            )
          ),
          _react2.default.createElement(
            _Button2.default,
            { id: "logout", onClick: onClick },
            "Log out"
          )
        )
      )
    );
  }
}

TopHeaderProfile.propTypes = {
  user: _propTypes2.default.shape({
    email: _propTypes2.default.string,
    avatar: _propTypes2.default.string
  }).isRequired,
  /**
   * Note: onClick for logout button in dropdown
   */
  onClick: Function.prototype
};

exports.default = TopHeaderProfile;